import AppConstant from "../assets/js/AppConstant";

export const uploadFileService = async (file, fileType, fileName) => {
  const blobUrl = `${AppConstant.STOARGE_ACCOUNT}/ticket-files/${fileName}?${AppConstant.STORAGE_TOKEN}`;

  try {
    const myHeaders = new Headers();
    myHeaders.append("x-ms-blob-type", "BlockBlob");
    myHeaders.append("Content-Type", fileType);
    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: file,
      redirect: "follow",
    };
    await fetch(blobUrl, requestOptions);
    return fileName;
  } catch (e) {
    void e;
  }
};

export const downloadPublicBlobFile = async (url) => {
  try {
    window.open(
      `${AppConstant.STOARGE_ACCOUNT}/ticket-files/${url}?${AppConstant.STORAGE_TOKEN}`,
      "_blank"
    );
  } catch (e) {
    void e;
  }
};

export const getBlobFilePath = (fileName) => {
  return `${AppConstant.STOARGE_ACCOUNT}/ticket-files/${fileName}?${AppConstant.STORAGE_TOKEN}`;
};

export const createFileFromBlobUrl = async (fullUrl) => {
  try {
    const response = await fetch(fullUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blobData = await response.blob();

    const fileName = fullUrl.split("/").pop().split("?")[0];
    const fileExtension = fileName.split(".").pop().toLowerCase();
    let fileType;

    switch (fileExtension) {
      case "png":
        fileType = "image/png";
        break;
      case "jpg":
      case "jpeg":
        fileType = "image/jpeg";
        break;
      case "svg":
        fileType = "image/svg+xml";
        break;
      case "pdf":
        fileType = "application/pdf";
        break;
      case "doc":
        fileType = "application/msword";
        break;
      case "docx":
        fileType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        break;
      default:
        fileType = blobData.type || "application/octet-stream";
    }
    const file = new File([blobData], fileName, { type: fileType });
    return file;
  } catch (error) {
    void error;
  }
};
